import { Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { DominioDto } from '../../../dto/justino/dominio.dto';
import { DominioService } from '../../../services/dominio.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { SpinnerService } from '../../../services/util/spinner.service';
import { FormControl, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { VideoDto } from '../../../dto/justino/video';
import { lastValueFrom } from 'rxjs';
import { EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-modal-editar-video',
  templateUrl: './modal-editar-video.component.html',
  styleUrl: './modal-editar-video.component.scss',
})
export class ModalEditarVideoComponent implements OnInit {
  

  @ViewChild('modalEditarVideo')
  modalEditar!: ElementRef;

  @Input() elements: any[] = [];

  //@Input() video: DominioDto | null = null;
  video: DominioDto | null = null;

  videoForm!: FormGroup;

  @Output() updateEmitter = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
    this.videoForm = new FormGroup({
      videoName: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9-]+$/), this.uniqueNameValidator(this.elements)]),
      videoUrl: new FormControl('', Validators.required),
    });
  }

  openCloseModal(video: DominioDto | null) {
    if (video) {
      this.video = video;
      this.videoForm.patchValue({
        videoName: video.Nombre,
        videoUrl: video.videoUrl,
      });
    } else {
      this.videoForm.reset();
    }
    this.modalEditar.nativeElement.click();
  }

  submitForm(): void {
      if (this.videoForm.valid) {
        this.updateEmitter.emit(this.videoForm.value);
        this.openCloseModal(null);
      } else {
        this.videoForm.markAllAsTouched();
      }
  }

  uniqueNameValidator(existingElements: any[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const nameExists = existingElements.some(el => {
        if (typeof el === 'string') {
          return el.toLowerCase() === control.value.toLowerCase() && el !== this.video?.Nombre;
        } else {
          return el.Nombre.toLowerCase() === control.value.toLowerCase() && el.Nombre !== this.video?.Nombre;
        }
      });
      return nameExists ? { nameExists: true } : null;
    };
  }
}
